<input
  #fileInput
  type="file"
  [accept]="accept"
  [multiple]="multiple"
  [attr.capture]="capture || null"
  [disabled]="disabled"
  (change)="onFileSelected($event)"
  class="hidden"
/>
<button
  bv-button
  [variant]="variant"
  [disabled]="disabled"
  (click)="fileInput.click()"
  type="button"
  class="inline-block cursor-pointer disabled:cursor-not-allowed"
>
  <ng-content></ng-content>
</button>